import { useEffect } from "react";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { toast } from "react-toastify";

import { updateAvailability } from "../../services/AvailabilityService";
import yup from "../../utils/yup";
import Form from "../../components/form/Form";

const AvailabilityHoursUpdate = ({ availabilityId, hours, setRequests, onClose }) => {
  const schema = yup
    .object()
    .shape({
      hours: yup
        .number()
        .required("The hours field is required.")
        .min(0, "The hours must be greater than 0.")
        .typeError("The hours field is required."),
    })
    .required();

  const form = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  useEffect(() => {
    if (hours) {
      form.setValue("hours", hours);
    }
  }, [hours]);

  return (
    <Form
      form={form}
      formDetails={{
        submitButtonLabel: "Submit",
        steps: [
          {
            name: "hours",
            placeholder: "Number of available hours",
            type: "text",
          },
        ],
      }}
      onSubmit={(values) =>
        updateAvailability(form.setError)({
          availabilityId,
          hours: values["hours"],
        }).then((data) => {
          setRequests((oldVal) =>
            oldVal.map((i) => {
              return {
                ...i,
                availabilities: i.availabilities.map((availability) => {
                  if (availability.id === data[0].id) {
                    return { ...availability, hours: data[0].hours };
                  }
                  return availability;
                }),
              };
            })
          );
          onClose();
          toast.success("The availability has been updated.");
        })
      }
    />
  );
};

export default AvailabilityHoursUpdate;
